import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 1% 2%;
	overflow: auto;
	height: inherit;
`;

export const RecordWraper = styled.div`
	padding: 5px 0 0 0;
`;

export const OptionsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-between;
`;

export const RangeReviewWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
`;

export const RangeWrapper = styled.div`
	width: 50%;
	padding: 0 15px;
	display: flex;
	align-items: center;
	flex-direction: row;
	justify-content: flex-end;
`;

export const InputLabel = styled.div`
	padding: 0 5px 0 0;
	font-size: 14px;
	color: ${colors.grey500};
`;

export const InputWrapper = styled.div`
	.start_rowindex {
		margin: 0 10px 0 0;
		div:first-child {
			display: none;
		}
	}
	.end_rowindex {
		div:first-child {
			display: none;
		}
	}
`;

export const ProcessingMessage = styled.div`
	text-align: center;
	font-size: 16px;
	padding: 5%;
`;

export const NoRowsAvailable = styled.div`
	text-align: center;
	font-size: 16px;
	padding: 5%;
`;
